import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { PaginatorFetcher, PaginatorFilters, TableComponent, TableConfig } from '@michelin/theme';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { DistributorDto } from 'src/app/shared/models/distributor/distributor-dto';
import { DealershipDto } from 'src/app/shared/models/dealership/dealership-dto';
import { DealershipService } from 'src/app/shared/services/dealership/dealership.service';
import { DistributorService } from 'src/app/shared/services/distributor/distributor.service';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';

@Component({
    selector: 'app-list-dealership',
    templateUrl: './list-dealership.component.html',
    standalone: false
})
export class ListDealershipComponent implements OnInit {
  data = {
    automakers: [] as AutomakerDto[],
    distributors: [] as DistributorDto[]
  };

  loading: boolean = false;

  tableConfig: TableConfig<DealershipDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      automaker: {
        header: 'OE',
        sortable: true,
        cell: (item) => item.automaker?.company?.tradeName,
        sortKey: 'automaker.company.tradeName'
      },
      code: { header: 'Cód.', sortable: true, cell: (item) => item.code },
      companyName: { header: 'Nome Fantasia', sortable: true, cell: (item) => item.company?.tradeName, sortKey: 'company.tradeName' },
      tradeName: { header: 'Razão Social', sortable: true, cell: (item) => item.company?.tradeName, sortKey: 'company.companyName' },
      document: { header: 'CNPJ', sortable: true, cell: (item) => item.company?.document, sortKey: 'company.document' },
      state: {
        header: 'UF',
        sortable: true,
        cell: (item) => item.company?.address?.city?.state?.code,
        sortKey: 'company.address.city.state.code'
      },
      distributor: {
        header: 'DE',
        sortable: true,
        cell: (item) => item.distributor?.company?.tradeName,
        sortKey: 'company.address.city.cityAttributes.distributor.company.tradeName'
      },
      enabled: { header: 'Ativo', cell: 'activeCell', sortable: true, sortKey: 'status' },
      // deleted: { header: 'Excluído', cell: 'removedCell', sortable: true },
      actions: { cell: 'actionsCell', header: ' ' }
    }
  };

  filterForm: FormGroup = this.form.group({
    code: this.form.control('', { nonNullable: true }),
    companyName: this.form.control('', { nonNullable: true }),
    tradeName: this.form.control('', { nonNullable: true }),
    document: this.form.control('', { nonNullable: true }),
    automaker: this.form.control({}, { nonNullable: true }),
    distributor: this.form.control({}, { nonNullable: true }),
    status: this.form.control('', { nonNullable: true })
  });

  fetcher: PaginatorFetcher<DealershipDto> = (filters: PaginatorFilters) => this.dealershipService.search(filters);

  @ViewChild(TableComponent, { static: true }) table: TableComponent<DealershipDto>;

  constructor(
    private readonly form: FormBuilder,
    private readonly router: Router,
    private readonly dealershipService: DealershipService,
    private readonly distributorService: DistributorService,
    private readonly automakerService: AutomakerService
  ) {}

  get filterValues(): any {
    return {
      code: this.filterForm.value.code,
      companyName: this.filterForm.value.companyName,
      tradeName: this.filterForm.value.tradeName,
      document: this.filterForm.value.document,
      status: this.filterForm.value.status,
      automakerId: this.filterForm.value.automaker?.id,
      distributorId: this.filterForm.value?.distributor?.id
    };
  }

  get automaker(): FormControl {
    return this.filterForm.get('automaker') as FormControl;
  }

  get distributor(): FormControl {
    return this.filterForm.get('distributor') as FormControl;
  }

  ngOnInit() {
    forkJoin({
      automakers: this.automakerService.findAll(),
      distributors: this.distributorService.findAll()
    }).subscribe({
      next: (result) => (this.data = result),
      complete: () => (this.loading = false)
    });
  }

  companyDisplayName(data: any): string {
    return data?.company?.tradeName;
  }

  applyFilter() {
    this.table.patchExtraFilters(this.filterValues, true);
  }

  resetFilter() {
    this.filterForm.reset();
    this.table.patchExtraFilters(this.filterValues, true);
  }

  redirectToEdit(item: DealershipDto) {
    this.router.navigate([`/dealerships/${item.id}/update`]);
  }
}
